import { ILegTrain, ISelectedTrainLegs } from "../../Orchestrator/Types/Index";

/**
 * Canonical builder for the End-to-end Journey leg list.
 *
 * Both the Booking-Details page (MainTrainInfoSection) and the Checkout page
 * ("Add Onward Travel" card) need the same ordered `ILegTrain[]` to drive the
 * End-to-end Journey drawer. The legs themselves are produced upstream by
 * GetLegsSummaryFromTripAction and stored in `selectedTrainLegsAtom`
 * (ISelectedTrainLegs); this helper takes that source of truth, combines the
 * outbound and inbound directions, and sorts the legs by start time — the exact
 * transform that previously lived inline in MainTrainInfoSection
 * (`sortTripsByStartTime`).
 *
 * Returns [] when the source / its legs are missing.
 */

const getLegStartTimestamp = (trip: ILegTrain): number => {
    const startDate = trip?.shortStartDateFormat || trip?.startTime;
    const parsed = startDate ? new Date(startDate).getTime() : Number.NaN;
    return Number.isNaN(parsed) ? Number.MAX_SAFE_INTEGER : parsed;
};

export const sortE2ELegsByStartTime = (trips: ILegTrain[] = []): ILegTrain[] =>
    [...trips].sort(
        (firstTrip, secondTrip) =>
            getLegStartTimestamp(firstTrip) - getLegStartTimestamp(secondTrip)
    );

export const buildE2ELegs = (
    selectedTrainLegs: ISelectedTrainLegs | null | undefined
): ILegTrain[] => {
    if (!selectedTrainLegs) return [];
    const combined = [
        ...(selectedTrainLegs.outbound || []),
        ...(selectedTrainLegs.inbound || []),
    ];
    if (combined.length === 0) return [];
    return sortE2ELegsByStartTime(combined);
};
